import { ReactNode } from 'react';

export interface PropInfo<T> {
  /**
   * Default value for the prop.
   */
  default?: string;

  /**
   * A useful description of what the prop is for.
   */
  description?: ReactNode;

  /**
   * Name of the prop in question.
   */
  name: keyof T;

  /**
   * Type of the prop, usually from prop-types.
   */
  type: string;
}
